import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import Pagination from "components/common/Pagination";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ReactTableWrapper from "components/reacttable/reacttbl.style";
import classnames from "classnames";
import { deleteSubUser, getAllMerchants } from "services/usersServices";
import NavigationActions from "redux/navigation/actions";
import { compose } from "redux";
import { Modal } from "reactstrap";
import ConformationModalUser from "components/common/ConformationModalUser";
import { updateUserStatus } from "services/merchantAuthServices";

import Loader from "components/Loader";
import { Switch } from "@mui/material";
import AddUsers from "./AddUsers";

const { success, error, fetching } = NavigationActions;
let debounceTimer;

const HeaderComponent = props => {
  let classes = {
    "-sort-asc": props.isSortedDesc !== undefined && !props.isSortedDesc,
    "-sort-desc": props.isSortedDesc !== undefined && props.isSortedDesc
  };
  return <div className={classnames(classes)}>{props.title}</div>;
};

const Users = props => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageLength, setPageLength] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [sortObject, setSortObject] = useState({ id: "id", desc: false });
  const { token, success, error, fetching, user } = props;
  const [refresh, toggleRefresh] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState("0");
  // const [addLoader, setAddLoader] = useState(false);
  const [isLoad, setLoader] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [addUserModal, showAddUserModal] = useState(false);
  const [deleteUserModal, showDeleteUserModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [isEditRequest, setIsEditRequest] = useState(false);
  const [editUser, setEditUser] = useState({});
  const [warningModal, setWarningModal] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Sr No."
            />
          );
        },
        placeholder: "",
        disableFilters: true,
        accessor: "id",
        Cell: tableInstance =>
          tableInstance.row.index + 1 + currentPage * pageLength
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Full Name"
            />
          );
        },
        placeholder: "Full Name",
        disableFilters: true,
        accessor: "name",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {tableInstance.row.values.name}
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Email"
            />
          );
        },
        placeholder: "Email",
        disableFilters: true,
        accessor: "email"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Status"
            />
          );
        },
        disableFilters: true,
        disableSort: true,
        accessor: "user_status",
        Cell: tableInstance => (
          <div className="react-action-class">
            <Switch
              checked={tableInstance.row.original.user_status}
              onChange={e => handleUpdateStatus(tableInstance.row.original)}
            />
          </div>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Mobile"
            />
          );
        },
        placeholder: "Mobile",
        disableFilters: true,
        accessor: "phone_number"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Action"
            />
          );
        },
        disableFilters: true,
        disableSort: true,
        accessor: "Action",
        Cell: tableInstance => (
          <div className="react-action-class">
            <button
              className="react-table-edit-button"
              onClick={() => {
                setIsEditRequest(true);
                setEditUser(tableInstance.row.original);
                showAddUserModal(true);
              }}
            >
              <i className="far fa-edit"></i>
            </button>
            <button
              className="react-table-delete-button"
              onClick={() => {
                setDeleteId(tableInstance.row.original._id);
                showDeleteUserModal(true);
              }}
            >
              <i className="far fa-trash-alt"></i>
            </button>
          </div>
        )
      }
    ],
    // eslint-disable-next-line
    [usersList]
  );
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    rows,
    headerGroups,
    state: { sortBy }
  } = useTable(
    {
      data: usersList,
      columns: columns,
      manualSortBy: true,
      initialState: {
        pageSize: pageLength,
        pageIndex: 0
      }
    },
    useSortBy,
    usePagination
  );
  const handleUpdateStatus = async user => {
    setLoader(true);
    let { user_status, _id } = user;
    await updateUserStatus(token, _id, { status: !user_status }).then(res => {
      if (res.success) {
        success(res.message);
        toggleRefresh(true);
        setLoader(false);
      } else {
        error(res.message);
        setLoader(false);
      }
    });
    setLoader(false);
  };

  const callApi = useCallback(async () => {
    const params = {
      page: currentPage + 1,
      limit: pageLength,
      search: searchText,
      sort_on: sortObject.id ? sortObject.id : "createdAt",
      sort:
        sortObject.desc !== undefined
          ? sortObject.desc
            ? "desc"
            : "asc"
          : "desc"
      // sortBy: sortObject,
    };

    await getAllMerchants(token, params).then(data => {
      fetching();
      if (data.success) {
        setUsersList(data.data.docs);
        setTotalRecords(data.data.totalDocs);
        setTotalPage(data.data.totalPages);
        toggleRefresh(false);
        success();
        setLoader(false);
      } else {
        error(data.message);
        setLoader(false);
      }
    });
    // eslint-disable-next-line
  }, [currentPage, pageLength, sortObject, refresh, searchText]);
  useEffect(() => {
    // Call api here
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    debounceTimer = setTimeout(() => {
      // setPageLength(10);
      callApi();
    }, 1000);
  }, [currentPage, sortObject, callApi]);

  useEffect(() => {
    // Call api here
    setCurrentPage(0);
  }, [sortObject, pageLength]);

  useEffect(() => {
    setSortObject({ ...sortBy[0] });
  }, [sortBy]);

  const handlePageChange = page => {
    fetching();
    setCurrentPage(page);
  };

  const closeAddModal = () => {
    showAddUserModal(false);
  };

  const handleDeleteUser = async () => {
    let id = deleteId;
    setLoader(true);
    await deleteSubUser(token, id).then(response => {
      if (response.success) {
        success(response.message);
        toggleRefresh(true);
        showDeleteUserModal(false);
        setLoader(false);
      } else {
        showDeleteUserModal(false);
        error(response.message);
        setLoader(false);
      }
    });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row title-sec align-items-center">
          <div className="col-sm headline">Merchants</div>
          <div className="col-sm-auto ml-auto"></div>
        </div>
        <div className="row align-items-center my-3">
          {/* <div className="col-auto">
            <label className="mr-2">Results :</label>
          </div>
          <div className="pl-0" style={{ width: "200px" }}>
            <Select
              id="pagination"
              className="page-result"
              value={pageOptions.find(x => x.value === pageLength)}
              onChange={e => {
                setLoader(true);
                setPageLength(e.value);
              }}
              options={pageOptions}
            />
          </div> */}
          <div className="col-md-4">
            <div className="icon-form-control">
              <i class="fas fa-search"></i>
              <input
                value={searchText ? searchText : ""}
                onChange={e => {
                  setCurrentPage(0);
                  setSearchText(e.target.value);
                }}
                type="text"
                placeholder="Search users..."
                className="form-control log-form-control react-form-input"
              />
            </div>
          </div>
        </div>
        <div className="div-container">
          <ReactTableWrapper {...props}>
            {/* <div className="row title-sec align-items-center">
              <div className="row title-sec align-items-center">
                <div className="col-sm headline"></div>
              </div>
            </div> */}
            <div className="table-responsive common-table card-box grey-box mb-2">
              <table className="table border-0" {...getTableProps()}>
                <thead className="thead-color text-center">
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(header => (
                        <th
                          className="thead-color"
                          {...header.getHeaderProps(
                            header.getSortByToggleProps()
                          )}
                        >
                          <div>{header.render("Header")}</div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="text-center">
                  {isLoad ? (
                    <tr>
                      <td colSpan={4}>
                        <Loader colspan={columns?.length} />
                      </td>
                    </tr>
                  ) : rows.length > 0 ? (
                    rows.map(row => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map(cell => (
                            <td className="td-border" {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="td-border" colSpan={columns?.length}>
                        <h6>No Data Found</h6>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="row align-items-center table-footer">
              <div className="col-sm-6 text-center text-sm-left">
                <span className="total-entry">
                  Showing{" "}
                  {/* {totalRecords === 0 ? 0 : currentPage * pageLength + 1} to{" "} */}
                  {Math.min(
                    currentPage * pageLength + usersList.length,
                    totalRecords
                  )}{" "}
                  of {totalRecords} entries
                </span>
              </div>
              <div className="col-sm-6">
                <Pagination
                  onPageChange={handlePageChange}
                  pages={totalPage}
                  page={currentPage}
                  // onPageChange={gotoPage}
                  // pages={pageCount}
                  // page={pageIndex}
                />
              </div>
            </div>
          </ReactTableWrapper>
        </div>
      </div>
      {addUserModal ? (
        <Modal isOpen={addUserModal} backdrop={true} centered>
          <AddUsers
            closeAddModal={closeAddModal}
            refresh={() => toggleRefresh(true)}
            isEditRequest={isEditRequest}
            editUser={editUser}
            setEditRequest={() => setIsEditRequest(false)}
          />
        </Modal>
      ) : null}
      {deleteUserModal ? (
        <Modal isOpen={deleteUserModal} backdrop={true} centered>
          <ConformationModalUser
            isOpen={deleteUserModal}
            onClose={() => showDeleteUserModal(false)}
            confirmText={"Delete"}
            cancelBtnBsStyle=" modalcancelbutton btn-secondary"
            message={"Are you sure you want to delete this user?"}
            handleConfirm={() => handleDeleteUser()}
            modalPurpose={"delete"}
          />
        </Modal>
      ) : null}
      {warningModal ? (
        <Modal
          isOpen={warningModal}
          toggle={() => {
            setWarningModal(false);
            props.history.push("/admin/merchants");
          }}
          centered
        >
          <ConformationModalUser
            isOpen={warningModal}
            onClose={() => {
              setWarningModal(false);
              props.history.push("/admin/merchants");
            }}
            confirmText={"Subscribe"}
            cancelBtnBsStyle=" modalcancelbutton btn-secondary"
            message={"Please purchase subscription to add user"}
            handleConfirm={() => props.history.push("/subscription")}
            modalPurpose={"alert"}
          />
        </Modal>
      ) : null}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user,
    channel: state.navigation.channel
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    success,
    error,
    fetching
  })
)(Users);
